/*-----------------------------------------------------------------
- ImageGallery
-----------------------------------------------------------------*/
export default {
    modal: {
        original_image: 'تصاویر رسمی',
    },
};
